import checkrApiClient from '../checkrApiClient';
import {
  CHECKR_BFF_API_BASE,
  SESSION_STORAGE_TOKEN_KEY,
} from '../../constants';
import {
  PromptGroup,
  CandidateStoryRequest,
} from '../../types/candidateStories';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
};

const baseUrl = `${CHECKR_BFF_API_BASE}`;

export const getCandidateStoryPrompts = async (
  account_id: string,
): Promise<{
  data: PromptGroup[];
}> => {
  const response = await checkrApiClient.get<{ data: PromptGroup[] }>(
    `${baseUrl}/candidate_stories/prompt_groups`,
    {
      params: {
        token: window.sessionStorage.getItem(SESSION_STORAGE_TOKEN_KEY),
        account_id,
      },
      headers,
    },
  );
  return response.data;
};

export const getCandidateStoryRequests = async (
  report_id: string,
): Promise<CandidateStoryRequest> => {
  const response = await checkrApiClient.get<CandidateStoryRequest>(
    `${baseUrl}/candidate_stories/requests`,
    {
      params: {
        token: window.sessionStorage.getItem(SESSION_STORAGE_TOKEN_KEY),
        report_id,
      },
      headers,
    },
  );
  return response.data;
};
